import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';


/**
 * A component that wraps a textarea. As text is entered into the textarea, the
 * textarea will expand. It'll shrink as text is deleted.
 */
export const ResizingTextarea = createReactClass({
    propTypes: {
        value: PropTypes.string,
        onChange: PropTypes.func,
    },

    mixins: [PureRenderMixin],

    getInitialState() {
        return { style: { overflow: 'hidden' } };
    },

    recalculateHeight() {
        // scrollHeight doesn't take into account the extra 2px needed to account for border
        // Also adding another 15 to prevent jitter immediately after hitting enter.
        // (Without that extra space, the top row hides (due to overflow: hidden) while the resize is happening)
        // It'd be better if we could avoid this.
        var scrollHeight = this.dummy.scrollHeight + 2 + 15;
        this.setState({
            style: {
                height: scrollHeight,
                overflow: 'hidden',
            },
        });
    },

    componentDidUpdate(prevProps, prevState) {
        if (this.props.value !== prevProps.value && this.textarea) {
            this.recalculateHeight();
        }
    },

    render() {
        // We have to create a dummy element because otherwise our modifications of this
        // textarea's height prevents us from recalculating desired height correctly
        var dummyStyle = {
            position: 'absolute',
            top: -10000,
            left: -10000,
        };
        return (
            <div>
                <textarea className="resizable" style={dummyStyle} ref={(t) => { this.dummy = t; } } value={this.props.value} disabled={true} aria-hidden={true} />
                <textarea autoFocus="true" className="resizable" style={this.state.style} ref={(t) => { this.textarea = t; } } value={this.props.value} onChange={this.props.onChange} />
            </div>
        );
    },
});
